<template>
    <div class="menu-page">
        <div class="search-box">
            <el-form :inline="true" size="mini" :model="formSearch" class="demo-form-inline">
            <el-form-item label="商品标题" prop="title">
                <el-input v-model="formSearch.title"></el-input>
            </el-form-item>

            <el-form-item label="商品类目" prop="item_cate_id">
                <el-select v-model="formSearch.itemCategoryId" placeholder="请选择" filterable>
					<el-option label="全部分类" :value="0"></el-option>
                    <el-option :label="c.name" :value="c.id" v-for="(c,i) in itemCates" :key="i">
                        <template>
                            <span style="padding-right: 15px;" v-for="z in c.depth" :key="z"></span>{{c.name}}
                        </template>
                    </el-option>
				</el-select>
            </el-form-item>

            <el-form-item label="价格" prop="price">
                <div flex="">
                    <el-input style="width: 130px;" v-model="formSearch.priceMin"></el-input>
                    <span>-</span>
                    <el-input style="width: 130px;" v-model="formSearch.priceMax"></el-input>
                </div>
            </el-form-item>

            <el-form-item label="上架状态" prop="status">
                <el-select v-model="formSearch.status">
                    <el-option label="全部" :value="-1"></el-option>
					<el-option label="仓库中" :value="0"></el-option>
					<el-option label="出售中" :value="1"></el-option>
                </el-select>
            </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

		<div class="table-box">
			<el-table :data="tableData" size="mini" v-loading="tableLoading" stripe border style="width: 100%">
				<el-table-column prop="id" label="商品ID" width="70"></el-table-column>
				<el-table-column prop="thumbnail" label="封面图" width="60"><template slot-scope="scope"><el-image style="width: 30px; height: 30px;" :src="$util.img(scope.row.thumbnail)" :preview-src-list="[$util.img(scope.row.thumbnail)]"></el-image></template></el-table-column>
				<el-table-column prop="title" label="商品标题">
                    <template slot-scope="scope">
                        <div class="f12 line-2 cp" v-html="$util.showKeyword(scope.row.title, formSearch.title)"></div>
                        <!-- <div class="f12 text-gray line-2 cp" v-html="$util.showKeyword(scope.row.subtitle, formSearch.title)"></div> -->
                    </template>
                </el-table-column>
				<el-table-column prop="itemCategory.name" label="商品类目" width="130"></el-table-column>
				<el-table-column prop="market_price" label="商品价格" width="100">
                    <template slot-scope="scope">
                        <div class="f12">
                            ￥{{scope.row.price}}

                        <el-tooltip class="item" effect="dark" content="快速修改商品价格" placement="top">
                            <a href="javascript:;" class="btn-a f12 fa fa-edit" @click="toEditPrice(scope.row)"></a>
                        </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
				<el-table-column prop="show_count" label="数据" width="60">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="" placement="top">
                            <div slot="content" class="f12">点击数：{{scope.row.showCount}} / 销量：{{scope.row.saleCount}}</div>
                            <div class="fa fa-eye primary"></div>
                        </el-tooltip>
                    </template>
                </el-table-column>
				<!-- <el-table-column prop="stock" label="库存" width="60">
                    <template slot-scope="scope">
                        <span class="cp f12">
                            {{scope.row.stock}}
                        <el-tooltip class="item" effect="dark" content="快速修改商品库存" placement="top">
                            <a href="javascript:;" class="btn-a f12 fa fa-edit" @click="toEditStock(scope.row)"></a>
                        </el-tooltip>
                        </span>
                    </template>
                </el-table-column> -->
				<el-table-column prop="status" label="上架状态" width="80"><template slot-scope="scope"><span class="f12" v-if="scope.row.status == 0">仓库中</span><span class="f12" v-if="scope.row.status == 1">出售中</span></template></el-table-column>
				<el-table-column prop="createdAt" label="发布时间" width="150"></el-table-column>
				<el-table-column label="#" width="120" fixed="right">
					<template slot-scope="scope">
						<a href="javascript:;" class="btn-a f12 padding-left-10" @click="selectRow(scope.row)" v-if="$util.checkPermission('RoleEdit')">选择</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="margin-top: 20px; margin-bottom: 20px;">
			<el-pagination background layout="total, prev, pager, next" :page-size="15" :current-page.sync="currentPage" @current-change="pageChange" :total="total"></el-pagination>
		</div>

		<el-dialog title="发布授权商品" :visible.sync="createDialog" append-to-body width="80%">
			<create v-if="createDialog" @createOk="createOk" @cancelCreate="cancelCreate"></create>
		</el-dialog>
		<el-dialog title="编辑授权商品" :visible.sync="editDialog" append-to-body width="80%">
			<edit v-if="editDialog" :id="currentRow ? currentRow.id : 0" @cancelEdit="cancelEdit" @editOk="editOk"></edit>
		</el-dialog>
		<el-dialog title="修改商品库存" :visible.sync="editStockDialog" append-to-body width="600px">
            <EditStock v-if="editStockDialog" :row="currentRow" @success="editStockSuccess" @cancel="editStockDialog = false"></EditStock>
		</el-dialog>
		<el-dialog title="修改授权商品价格" :visible.sync="editPriceDialog" append-to-body width="600px">
            <EditPrice v-if="editPriceDialog" :row="currentRow" @success="editPriceSuccess" @cancel="editPriceDialog = false"></EditPrice>
		</el-dialog>
    </div>
</template>

<script>
import mixin from '@/assets/js/mixin.js'
export default {
    mixins: [mixin],
    data(){
        return {
            moduleType: 'rItem',
            module: 'item',
            itemCates: [],

            editStockDialog: false,
            editPriceDialog: false,
        }
    },
    components: {
    },
    methods: {
        init(){
            this.$emit('loadOk');
            this.params.type = 2
            this.getLists()
            this.getItemCates()
        },
        selectRow(row){
            this.$emit('success', row)
        },
        toEditPrice(row){
            this.currentRow = row
            this.editPriceDialog = true
        },
        editPriceSuccess(){
            this.editPriceDialog = false
            this.getLists(this.currentPage)
        },
        toEditStock(row){
            this.currentRow = row
            this.editStockDialog = true
        },
        editStockSuccess(){
            this.editStockDialog = false
            this.getLists(this.currentPage)
        },
        onSearch(){
            this.params.title = this.formSearch.title
            this.params.itemCategoryId = this.formSearch.itemCategoryId
            this.params.status = this.formSearch.status
            this.params.priceMin = this.formSearch.priceMin
            this.params.priceMax = this.formSearch.priceMax
            this.getLists()
        },
        async getItemCates(){
            let res = await this.$api.rApi('item/category/lists/all', {
                type: 'select-lists',
            })
            if(res.status == 1){
                this.setParents(res.data, 0, -1)
            }
        },
        setParents(data, parentId, depth){
            for(var i in data){
                if(data[i].parentId == parentId){
                    let d = depth + 1;
                    this.itemCates.push({
                        id: data[i].id,
                        name: data[i].name,
                        depth: d
                    })
                    // 去找他的下级
                    if(data[i].childrenCount > 0){
                        this.setParents(data, data[i].id, d);
                    }
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/SelectScopeItem.vue